const isMainnetEnv = () => {
	const mainnetEnvs = ["uat", "production"]

	return mainnetEnvs.includes(import.meta.env.MODE?.toLowerCase())
}

export const getTransactionHashScanLink = (transactionId: string) => {
	const hashScanNet = isMainnetEnv() ? "mainnet" : "testnet"
	return `https://hashscan.io/${hashScanNet}/transaction/${transactionId}`
}
